import { takeEvery, takeLatest } from 'redux-saga/effects';
import {
  ACCEPT_REPRESENTATIVE_BY_ID,
  AUTHORIZED_CHECK, AUTHORIZED_ESIA_LOGIN, AUTHORIZED_ESIA_LOGOUT,
  AUTHORIZED_LOGIN,
  AUTHORIZED_LOGOUT, CALL_CALLBACK_ESIA, CREATE_REPRESENTATIVE,
  DELETE_NOTIFICATION, EDIT_REPRESENTATIVE,
  FORGOT_PASSWORD, GET_ESIA_URL, GET_PROFILE_COMPANIES, LOAD_APPLICANT_LIST,
  LOAD_NOTIFICATION,
  LOAD_NOTIFICATION_TYPES,
  LOAD_ORGANIZATION_LIST, LOAD_REPRESENTATIVE_BY_ID,
  LOAD_REPRESENTATIVE_LIST,
  LOAD_TRANSPORT_LIST,
  MARK_ALL,
  REFRESH_KEY_CLOAK, SET_COMPANY,
} from '../actions';
import { AUTHORIZED_MODULE } from '../../../configs/moduleNames';
import { FAILED, UPDATE } from '../../../configs/actionNames';

import authorizedCheck from './authorizedCheck';
import authorizedLogin from './authorizedLogin';
import authorizedLogout from './authorizedLogout';
import refreshKeyCloak from './refreshKeyCloak';
import loadOrganizationList from './loadOrganizationList';
import loadTransportList from './loadTransportList';
import loadNotification from './loadNotification';
import deleteNotification from './deleteNotification';
import loadNotificationTypes from './loadNotificationTypes';
import markAllNotification from './markAllNotification';
import authorizedESIALogin from './authorizedESIALogin';
import authorizedESIALogout from './authorizedESIALogout';
import getESIAUrl from './getESIAUrl';
import callCallbackEsia from './callCallbackEsia';
import getProfileCompanies from './getProfileCompanies';
import setCompany from './setCompany';
import loadRepresentativeList from './loadRepresentativeList';
import forgotPassword from './forgotPassword';
import loadRepresentativeById from './loadRepresentativeById';
import createRepresentative from './createRepresentative';
import loadApplicantList from './loadApplicantList';
import editRepresentative from './editRepresentative';
import acceptRepresentative from './acceptRepresentative';

export default function* watchClient() {
  // yield takeEvery(SYSTEM_MODULE + INIT_APP, initKeyCloak);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_LOGIN, authorizedLogin);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_LOGOUT, authorizedLogout);
  yield takeEvery(AUTHORIZED_MODULE + GET_ESIA_URL, getESIAUrl);
  yield takeEvery(AUTHORIZED_MODULE + CALL_CALLBACK_ESIA, callCallbackEsia);
  yield takeEvery(AUTHORIZED_MODULE + GET_PROFILE_COMPANIES, getProfileCompanies);
  yield takeEvery(AUTHORIZED_MODULE + SET_COMPANY, setCompany);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_ESIA_LOGIN, authorizedESIALogin);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_ESIA_LOGOUT, authorizedESIALogout);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_CHECK + FAILED, authorizedLogout);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_CHECK, authorizedCheck);
  yield takeEvery(AUTHORIZED_MODULE + FORGOT_PASSWORD, forgotPassword);
  yield takeEvery(AUTHORIZED_MODULE + REFRESH_KEY_CLOAK, refreshKeyCloak);
  yield takeEvery(AUTHORIZED_MODULE + LOAD_ORGANIZATION_LIST, loadOrganizationList);
  yield takeEvery(AUTHORIZED_MODULE + LOAD_TRANSPORT_LIST, loadTransportList);
  yield takeEvery(AUTHORIZED_MODULE + LOAD_REPRESENTATIVE_LIST, loadRepresentativeList);
  yield takeEvery(AUTHORIZED_MODULE + LOAD_NOTIFICATION, loadNotification);
  yield takeEvery(AUTHORIZED_MODULE + DELETE_NOTIFICATION, deleteNotification);
  yield takeEvery(AUTHORIZED_MODULE + LOAD_NOTIFICATION_TYPES, loadNotificationTypes);
  yield takeEvery(AUTHORIZED_MODULE + MARK_ALL, markAllNotification);
  yield takeEvery(AUTHORIZED_MODULE + CREATE_REPRESENTATIVE, createRepresentative);
  yield takeEvery(AUTHORIZED_MODULE + LOAD_REPRESENTATIVE_BY_ID, loadRepresentativeById);
  yield takeEvery(AUTHORIZED_MODULE + LOAD_APPLICANT_LIST, loadApplicantList);
  yield takeEvery(AUTHORIZED_MODULE + EDIT_REPRESENTATIVE, editRepresentative);
  yield takeEvery(AUTHORIZED_MODULE + ACCEPT_REPRESENTATIVE_BY_ID, acceptRepresentative);
}
